import {Button, DatePicker, Divider, Flex, Form, Input, InputNumber, Typography} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {ApiQuery} from '../../../gen/api';
import {useNotification} from '../../../NotificationContext';

const {Text} = Typography;

export const PalletOrderCreatePage: React.FC = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const notify = useNotification();

    const [error, setError] = React.useState<string | null>(null);

    const create = ApiQuery.useAdminCreatePalletMutation({
        onSuccess() {
            notify.openNotificationWithIcon('success', 'Pallet order created');
            navigate('/pallet-orders/');
        },
        onError() {
            setError('Something went wrong');
        },
    });

    const handleSubmit = () => {
        console.log('form', form);
        console.log('form', form.getFieldValue('marketplaces'));
        console.log('form', form.getFieldsValue());

        setError(null);
        create.mutate({
            params: {
                items: form.getFieldValue('items'),
                junkItems: form.getFieldValue('junkItems'),
                name: form.getFieldValue('name'),
                orderDate: form.getFieldValue('orderDate'),
                price: form.getFieldValue('price'),
                orderLink: form.getFieldValue('orderLink'),
            },
        });
    };

    return (
        <div>
            <h1>Create Pallet Order</h1>
            <Divider />
            <Form
                onFinish={handleSubmit}
                disabled={create.isLoading}
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{maxWidth: 600}}
                form={form}
            >
                <Form.Item
                    label="Name"
                    name="name"
                    rules={[{required: true, message: 'Please input name!'}]}
                >
                    <Input placeholder="name" />
                </Form.Item>
                <Form.Item
                    label="Order Date"
                    name="orderDate"
                    rules={[{required: true, message: 'Please input order date!'}]}
                >
                    <DatePicker />
                </Form.Item>
                <Form.Item
                    label="Items"
                    name="items"
                    rules={[{required: true, message: 'Please input items!'}]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label="Junk Items"
                    name="junkItems"
                    rules={[{required: true, message: 'Please input junk items!'}]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label="Price"
                    name="price"
                    rules={[{required: true, message: 'Please input price!'}]}
                >
                    <InputNumber />
                </Form.Item>
                <Form.Item
                    label="Order Link"
                    name="orderLink"
                    rules={[{required: true, message: 'Please input order link!'}]}
                >
                    <Input />
                </Form.Item>

                {error && <Text type={'danger'}>{error}</Text>}
                <Flex justify={'end'}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={create.isLoading}
                    >
                        Create
                    </Button>
                </Flex>
            </Form>
        </div>
    );
};
